import Component from '../inherited/Component'

export default class KeenSliderNav extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._mainSlider = this._theme.getComponent(this._options.parentSlider)
  }

  mount () {
    for (let [index, item] of this._elem.querySelectorAll('.keen-slider__nav-item').entries()) {
      item.addEventListener('click', e => {
        this._elem.querySelectorAll('.keen-slider__nav-item').forEach((element) => {
          (element == item) ? element.classList.add('is-active') : element.classList.remove('is-active')
        });
        this.goToSlide(index)
      })
    }

    this._ctx.on('keen-slider:change', payload => {
      this._elem.querySelectorAll('.keen-slider__nav-item').forEach(item => {
        if (Number(item.dataset.dot) === payload.activeSlide) {
          item.classList.add('is-active')
        } else {
          item.classList.remove('is-active')
        }
      })
    })
  }

  goToSlide(index) {
    this._mainSlider.component.goToSlide(index)
  }
}